/**
 * Keyboard navigation for the predictive search drawer.
 * ArrowDown / ArrowUp move between result links so the panel stays open
 * and every result is reachable without the mouse.
 * Tab uses native order (input → close → tabs → results).
 */
(function () {
  const DRAWER_ID = "search-drawer";
  // Scope to result items only — category tabs also live under
  // .predictive-search__results and must not steal ArrowDown/ArrowUp.
  const RESULT_SELECTOR = [
    ".predictive-search__results-categories a[href]",
    ".predictive-search__results-categories button:not([disabled])",
    ".predictive-search__results-categories [tabindex]:not([tabindex='-1'])",
  ].join(", ");

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function getQueryInput(drawer) {
    return drawer?.querySelector('.predictive-search__input[name="q"]');
  }

  function getVisibleResults(drawer) {
    const resultsRoot = drawer?.querySelector(".predictive-search__results");
    if (!resultsRoot || resultsRoot.hidden) {
      return [];
    }
    return Array.from(resultsRoot.querySelectorAll(RESULT_SELECTOR)).filter((el) => {
      return el.offsetParent !== null && !el.closest("[hidden]");
    });
  }

  function focusResult(results, index) {
    if (!results.length) {
      return;
    }
    const nextIndex = ((index % results.length) + results.length) % results.length;
    results[nextIndex].focus();
  }

  function onDrawerKeyDown(event) {
    const drawer = event.currentTarget;
    if (!drawer || !drawer.hasAttribute("open")) {
      return;
    }

    const results = getVisibleResults(drawer);
    if (!results.length) {
      return;
    }

    const active = document.activeElement;
    const input = getQueryInput(drawer);
    const resultIndex = results.indexOf(active);
    const onInput = active === input;
    const onResult = resultIndex >= 0;

    if (event.key === "ArrowDown") {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (onInput) {
        focusResult(results, 0);
      } else if (onResult) {
        focusResult(results, resultIndex + 1);
      } else {
        focusResult(results, 0);
      }
      return;
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (onResult) {
        if (resultIndex === 0 && input) {
          input.focus();
        } else {
          focusResult(results, resultIndex - 1);
        }
      }
    }
  }

  function bindDrawer(drawer) {
    if (!drawer || drawer.dataset.boaSearchA11yBound === "true") {
      return;
    }
    drawer.dataset.boaSearchA11yBound = "true";
    drawer.addEventListener("keydown", onDrawerKeyDown);
  }

  function init() {
    bindDrawer(getDrawer());
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Drawer is append-body'd; re-bind if the node is replaced on section re-render.
  document.addEventListener("openable-element:open", (event) => {
    if (event.target?.id === DRAWER_ID) {
      bindDrawer(event.target);
    }
  });
})();
